'use client';

import theme from '@/components/core/theme';
import { css } from '@linaria/core';

export const global = css`
  :global() {
    :root {
      --layout-navbar: 70px;
    }
  }
`;

export const root = css`
  display: grid;
  grid-template-areas:
    'navbar'
    'body'
    'footer';
  min-height: 100dvh;
  grid-template-rows: var(--layout-navbar) 1fr auto;
  @media screen and (width > ${theme.sizes.screens.md}) {
    --layout-navbar: 90px;
  }
`;

export const navbar = css`
  grid-area: navbar;
`;
export const body = css`
  grid-area: body;
  padding: 1rem 0;
  min-width: 0;
`;
export const footer = css`
  grid-area: footer;
  background: ${theme.colors.neutral[5]};
  padding: 1.5rem 0;
  color: ${theme.colors.neutral[3]};
`;

export const privacy = css`
  grid-area: privacy;
`;

export const copyright = css`
  grid-area: copyright;
`;

export const social = css`
  grid-area: social;
  display: flex;
  gap: 1rem;
  font-size: 24px;
  justify-content: center;
`;

export const footerContainer = css`
  font-weight: 500;
  display: grid;
  grid-template-areas:
    'social social'
    'privacy copyright';
  justify-content: space-between;
  @media screen and (width > ${theme.sizes.screens.md}) {
    grid-template-areas: 'privacy social copyright';
  }
`;
